<template>
	<vx-card id="company-card-main">
		<div slot="no-body" class="tabs-container px-6 pt-6" v-if="roleUpdatePermission">
			<div class="content">
				<RoleForm v-if="$route.params.hasOwnProperty('data')" :editable="true" :params="$route.params" />
			</div>
		</div>

		<not-permission v-else></not-permission>
	</vx-card>
</template>

<script>
import RoleForm from "../../components/role/RoleForm.vue";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	name: "UpdateRole",
	components: {
		RoleForm,
		NotPermission,
	},
	computed: {
		roleUpdatePermission() {
			return this.$store.getters.checkPermission("ROLE_U");
		},
	},
	created() {
		if (!this.$route.params.hasOwnProperty("data")) {
			this.$router.push({name: "role"});
		}
	},
};
</script>

<style>
.content {
	overflow: hidden;
}
</style>
